import { getUUID } from '@src/utils/uuid';

export const getFileObjects = (filteredAcceptedFiles) => {
  return filteredAcceptedFiles.map((f) => {
    const uuid = getUUID();
    f.uuid = uuid;
    f.loadingError = false;
    return {
      uuid,
      loading: true,
      loadingError: false,
      fileSize: f.size,
      originalName: f.name,
      originalFile: f,
    };
  });
};
